import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LoadingProvider } from '../../providers/loading/loading';

@Component({
  selector: 'custom-loading',
  templateUrl: 'custom-loading.html'
})
export class CustomLoadingComponent {

  constructor(
    private loading: LoadingProvider
  ) { }

  get isLoading(): BehaviorSubject<boolean> {
    return this.loading.isLoading$;
  }

}



// WEBPACK FOOTER //
// ./src/components/custom-loading/custom-loading.ts